// extracted by mini-css-extract-plugin
module.exports = {"svr-badge":"svr-badge___3bIsq","green":"green___1bKx8","clickable":"clickable___1jl_b","red":"red___3OMjd","remove-icon":"remove-icon___367Mp"};